import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import { AppButton } from "../ui";
import { Download, X } from "lucide-react";

const FilePreviewModal = ({ show, onHide, url, fileName, loading, isImage = true }) => (
  <Modal
    show={show}
    onHide={onHide}
    size="lg"
    centered
    contentClassName="file-modal-content"
    aria-labelledby="file-preview-modal"
    style={{ zIndex: "var(--z-modal)" }}
  >
    <Modal.Header closeButton className="border-0 pb-1">
      <Modal.Title id="file-preview-modal" className="fw-bold" style={{ fontSize: 20 }}>
        {fileName ? <span>{fileName}</span> : <span>File Preview</span>}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="d-flex flex-column align-items-center bg-light" style={{ minHeight: 320, borderRadius: 16 }}>
      {loading ? (
        <Spinner animation="border" variant="secondary" style={{ margin: "60px 0" }} />
      ) : url ? (
        isImage ? (
          <img
            src={url}
            alt={fileName}
            style={{
              maxWidth: "100%",
              maxHeight: "65vh",
              borderRadius: 16,
              boxShadow: "0 2px 16px rgba(50,60,90,0.12)",
              marginBottom: 12,
              background: "#eee",
            }}
          />
        ) : (
          <iframe
            src={url}
            title={fileName}
            style={{
              width: "100%",
              minHeight: 400,
              border: "none",
              borderRadius: 12,
              background: "#f5f6fa",
              boxShadow: "0 2px 10px #eee"
            }}
          />
        )
      ) : (
        <div className="text-muted">No file available.</div>
      )}
    </Modal.Body>
    <Modal.Footer className="justify-content-between border-0 pt-1">
      <AppButton variant="outline" onClick={onHide}>
        <X size="1em" className="me-1" /> Close
      </AppButton>
      {url && (
        <AppButton
          variant="outline"
          as="a"
          href={url}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Download size="1em" className="me-2" /> Download
        </AppButton>
      )}
    </Modal.Footer>
  </Modal>
);

export default FilePreviewModal;
